import { useState, useEffect } from 'libs/react';
import { SessionStorage } from 'libs/storage/SessionStorage';
/**
 * Hook to persist state in session storage
 * @function usePersistedState
 * @since 1.0.0
 */
export function usePersistedState(key, initialValue) {
    // Initialize state from session storage or use initial value
    const [state, setState] = useState(() => {
        const savedValue = SessionStorage.get(key, null);
        if (savedValue !== null) {
            return savedValue;
        }
        return initialValue;
    });
    // Save to session storage whenever state changes
    useEffect(() => {
        SessionStorage.set(key, state);
    }, [key, state]);
    return [state, setState];
}
